import {
  SET_SEARCH_SHIPMENT_DETAIL,
  EDIT_SEARCH_SHIPMENT_DETAIL,
} from "./actionType";

export default function reducer(state = [], action) {
  switch (action.type) {
    case SET_SEARCH_SHIPMENT_DETAIL: {
      return [...action.payload];
    }
    case EDIT_SEARCH_SHIPMENT_DETAIL: {
      return [
        ...state.slice(0, action.idx),
        {
          ...state[action.idx],
          ...action.payload,
        },
        ...state.slice(action.idx + 1),
      ];
    }
    default:
      return state;
  }
}
